
import React from "react";
import { motion } from "framer-motion";

interface AnimatedLoadingScreenProps {
  message?: string;
}

const AnimatedLoadingScreen: React.FC<AnimatedLoadingScreenProps> = ({ 
  message = "Loading..." 
}) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-6">
      <div className="w-full max-w-md">
        <div className="relative mb-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ 
              opacity: 1, 
              y: 0,
              transition: { 
                duration: 0.6, 
                ease: "easeOut" 
              }
            }}
            className="w-full"
          >
            <div className="relative">
              <motion.div
                animate={{ 
                  boxShadow: [
                    "0 25px 50px -12px rgba(0, 0, 0, 0.25)", 
                    "0 35px 60px -15px rgba(0, 0, 0, 0.3)", 
                    "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
                  ]
                }}
                transition={{ 
                  duration: 2, 
                  repeat: Infinity, 
                  repeatType: "reverse" 
                }}
                className="w-full h-full absolute inset-0 rounded-lg"
              />
              <motion.img
                src="/lovable-uploads/7fa3e3de-f021-4713-b0a0-aded28691cba.png"
                alt="Find My Filmmaker Logo"
                className="w-full h-auto relative z-10"
                animate={{
                  scale: [1, 1.03, 1],
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  repeatType: "reverse",
                  ease: "easeInOut"
                }}
              />
            </div>
          </motion.div>
        </div>

        <div className="text-center">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            <h3 className="text-primary text-xl font-medium mb-2">{message}</h3>
            <div className="flex justify-center items-center space-x-2">
              <motion.div 
                className="w-3 h-3 bg-primary rounded-full"
                animate={{ scale: [1, 1.5, 1] }}
                transition={{ 
                  duration: 1, 
                  repeat: Infinity, 
                  repeatDelay: 0.2 
                }}
              />
              <motion.div 
                className="w-3 h-3 bg-primary rounded-full"
                animate={{ scale: [1, 1.5, 1] }}
                transition={{ 
                  duration: 1, 
                  repeat: Infinity, 
                  repeatDelay: 0.2,
                  delay: 0.2
                }}
              />
              <motion.div 
                className="w-3 h-3 bg-primary rounded-full"
                animate={{ scale: [1, 1.5, 1] }}
                transition={{ 
                  duration: 1, 
                  repeat: Infinity, 
                  repeatDelay: 0.2,
                  delay: 0.4
                }}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AnimatedLoadingScreen;
